import './App.css';
import Home from "./pages/Home";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import CustomNavbar from "./components/CustomNavbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import EmailConfirmation from "./pages/EmailConfirmation";
import Games from "./pages/Games";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import Game from "./pages/Game";
import PaymentResponse from "./pages/payments/PaymentResponse";
import Product from "./pages/payments/Product";
import Products from "./pages/payments/Products";

function App() {
    return (
        <Router>
            <div style={{
                background: "linear-gradient(to top right, #071a3d, #000)",
                minHeight: "100vh"
            }}>
                <CustomNavbar key="customNavbar"/>
                <Routes>
                    <Route path="/" element={<Home />}/>
                    <Route path="/about" element={<About />}/>
                    <Route path="/signup" element={<Signup />}/>
                    <Route path="/login" element={<Login />}/>
                    <Route path="/email-confirmation" element={<EmailConfirmation />}/>
                    <Route path="/games" element={<Games />}/>
                    <Route path="/users/:username/profile" element={<Profile />}/>
                    <Route path="/users/:username/edit" element={<EditProfile />}/>
                    <Route path="/games/:gameName" element={<Game />}/>
                    <Route path="/products" element={<Products />}/>
                    <Route path="/products/:productId" element={<Product />}/>
                    <Route path="/payment-response" element={<PaymentResponse />}/>
                    <Route path="/sponsors" />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
